import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHomeIconSecondary from './svgs/HomeIconSecondary.js';
import SvgHomeIcon from './svgs/HomeIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var homeIcon = (props => useIcon(SvgHomeIcon, SvgHomeIconSecondary, props));

export { homeIcon as default };
